module.exports = __webpack_public_path__ + "images/category_lp/common/assessment_achievement_stamp_a2f00cd11a247882cf9a89ccad6f6c09.png";